























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import InputNumber from "@/components/common/input/InputNumber.vue";
import TireDialog from "@/components/tireDialog.vue";
import { Utils } from "@/service/util";
import carSelection from "@/page/factory/carSelection.vue";
import { Getter, Action } from "vuex-class";
import { CarSelectQuickInfoData } from "@/model/CarSelectionQuickInfo";
import { CarSelectQuickInfoCustomerData } from "@/model/CarSelectionQuickInfoCustomer";
import Pagination from "@/components/common/Pagination.vue";
import QuickMitsumoriListComponent from "@/components/QuickMitsumoriListComponent.vue";
import CustomerCarListComponent from "@/components/CustomerCarListComponent.vue";
import { ElTable } from "element-ui/types/table";

@Component({
  components: {
    Header,
    InputNumber,
    TireDialog,
    Pagination,
    QuickMitsumoriListComponent,
    CustomerCarListComponent
  }
})
export default class QuickInfo extends carSelection {

  convertedZipTable: ElTable;

  showDialogAskInfo = false;
  showDialogInfo = false;
  showDialogAskRegister = false;
  showDialogTouroku = false;
  loadingTouroku: boolean = false;
  showDialogZipselect = false;
  loadingZipselect: boolean = false;
  showDialogLaborRate = false;
  showDialogQuickMitsumori = false;
  showDialogCustomerCar = false;

  laborSelected: any = null;
  labors: any = [];

  // customerNm = "";
  customerInfo: any = {
    kojinNmKjMei: "",
    kojinNmKjSei: "",
    kojinNmKnMei: "",
    kojinNmKnSei: "",
    gender: null,
    birthday: null,
    address1: null,
    address2: null,
    prefCd: "",
    prefNm: "",
    zipcode: "",
    keitai: "",
    mailAddress: "",
    vehicleNm: ""
  };
  staffs: any = [];
  touroku: any = {
    srPlateAreaCd: "",
    srPlateModelNm: "",
    srPlateKanaNm: "",
    srPlateNo: ""
  };
  tourokuStaging: any = {
    srPlateAreaCd: "",
    srPlateModelNm: "",
    srPlateKanaNm: "",
    srPlateNo: ""
  };
  listPlateArea: any = [];
  listPrefectures: any =[];
  listConvertedZip: any =[];
  zipselectCurrentRow: any = {
    zipCode: "",
    prefName: "",
    address: ""
  };

  srPlateAreaCd: any = "";

  listPlateAreaFrequent: any = [
    // {srPlateAreaCd: "7412", srPlateAreaNm: "岡山"},
    // {srPlateAreaCd: "7413", srPlateAreaNm: "倉敷"},
    // {srPlateAreaCd: "5134", srPlateAreaNm: "尾張小牧"},
    // {srPlateAreaCd: "6133", srPlateAreaNm: "なにわ"},
    // {srPlateAreaCd: "5233", srPlateAreaNm: "富士山"},
    // {srPlateAreaCd: "6322", srPlateAreaNm: "姫路"},
    // {srPlateAreaCd: "7112", srPlateAreaNm: "広島"}
  ];

  currentRowSelectQuick: any;
  torokubangoDialogSelected: any = "";
  customerCarDialogSelected: any = {
  };

  // for pagination
  dataPageList: any = [];
  itemSizeSelected: number = 10;

  eluiList: any = [1,2,4,5,7,8,9,10,11,12,13,14,15,16];
  isModeQuick: boolean = true;
  isUserMode: boolean = false;

  carFormQuickInfo: CarSelectQuickInfoData = {} as CarSelectQuickInfoData;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;

  @Action("setUketsukeExtendsId", { namespace: "ReservationDetail" })
  setUketsukeExtendsId: any;

  @Action("updateFrontStaff", { namespace: "ReservationDetail"})
  updateFrontStaff: any;

  @Getter("currentState", { namespace: "CarSelectionQuickInfo" })
  currentStateQuickInfo: CarSelectQuickInfoData;

  @Action("setState", { namespace: "CarSelectionQuickInfo" })
  setStateQuickInfo: any;

  @Action("clearState", { namespace: "CarSelectionQuickInfo" })
  clearStateQuickInfo: any;

  @Getter("currentState", { namespace: "CarSelectionQuickInfoCustomer" })
  currentStateQuickCustomerInfo: CarSelectQuickInfoCustomerData;

  @Action("setState", { namespace: "CarSelectionQuickInfoCustomer" })
  setStateQuickCustomerInfo: any;

  @Action("clearState", { namespace: "CarSelectionQuickInfoCustomer" })
  clearStateQuickCustomerInfo: any;

  @Action("clearState", { namespace: "CarSelection" })
  clearState: any;

  @Watch("showDialogZipselect") public onChangeDialogZipselect() {
    if (!this.showDialogZipselect) {
      this.dataPageList = [];
      this.listConvertedZip =[];
      this.zipselectCurrentRow = "";
    }
  }

  /** 2021-10-12 sh #7465 call plate-areas when initialization. [START] */
  created() {
    if (this.$route.meta == "user") {
      this.isUserMode = true;
      // if ( this.isNextageCustom ) {
    //  eluiList: any = [2,3,4,6,7,8,9,10,11,12,13,14,15,16];
    } else {
    //  eluiList: any = [2,3,4,6,7,8,9,10,11,12,13,14,15,16];
        // 予約情報 / 入庫前確認
    }
    this.reqService.getPlateAreas().then((res: any) => {
      if (res) {
        this.listPlateArea = res;
      }
    });
  }
  /** 2021-10-12 sh #7465 call plate-areas when initialization. [END] */

  activeBtn( judge: boolean ) {
    
    if (judge) {
      if ( !this.isModeQuick && this.isUserMode ) {
        return 'red-active'; 
      } else {
        return 'orange-active'; // 通常色
      }
    } else {
      return '';
    }
  }

  onConfirmAddInfo() {
    this.showDialogAskInfo = false;
    this.showDialogInfo = true;
  }

  onNotAddInfo() {
    this.showDialogAskInfo = false;
    // this.customerNm = "上";
  }

  onAskRegister() {
    this.showDialogAskRegister = true;
  }

  onConfirmRegister() {
    // save labor
    let laborSelected = this.labors.find(
      (e: any) => e.laborRateCd == this.laborSelected
    );
    if (this.laborSelected && laborSelected) {
      // 車検点検:shakenTenken, 一般整備:seibi, 板金塗装:bankin, 保証:hoshou, クレーム:claim
      // クイック見積もりは車検で一旦固定
      this.carFormQuickInfo.laborRateKingakuZn = laborSelected.shakenTenken;
      this.carFormQuickInfo.laborRateCd = laborSelected.laborRateCd;
      this.carFormQuickInfo.laborRateNm = laborSelected.bunruiNm;
    }
    this.touroku = this.utils.deepCopy(this.tourokuStaging);

    // this.customerNm = this.customerInfo.kojinNmKjSei + '　' + this.customerInfo.kojinNmKjMei;
    this.onCloseRegister();
  }

  onCloseRegister() {
    // 元に戻すため、ここでコピーをしておく
    this.tourokuStaging = this.utils.deepCopy(this.touroku);  // staging

    this.showDialogAskRegister = false;
    this.showDialogInfo = false;
  }

  onSelectCurrentRowQuickMitsumori(e: any) {
    // console.log("quickinfo.onSelectCurrentRowQuickMitsumori e => ", e);
    this.currentRowSelectQuick = {...e};
    this.torokubangoDialogSelected = (e && e.sknQuickMitsumoriId) ? e.sknQuickMitsumoriId : "";
  }

  onCloseSearchQuickMitsumori() {
    // console.log("quickinfo.onCloseSearchQuickMitsumori currentRow => ", this.currentRowSelectQuick);
    this.showDialogQuickMitsumori=false;
    this.currentRowSelectQuick = null;
    this.torokubangoDialogSelected = "";
  }

  get isConfirmQuickSearchDisabled() {
    let isOK = true;

    if (!this.torokubangoDialogSelected) {
      isOK = false;
    }

    return !isOK;
  }

  setKbnList() { // mounted => setKbnList
    this.reqService.getPrefectures().then(list => {
      this.listPrefectures = list;
    });
    this.reqService.getStaffFront().then(
      (res: any) => {
        if (res) {
          this.staffs = res;
          if (this.carFormQuickInfo.frontTantoushaCd == null || this.carFormQuickInfo.frontTantoushaCd == "") {
            if (this.staffs.length > 0) {
              // mountedですると、タイミングによりセットされない。親クラスのcreatedのpromise内にあるgetDataがズレて呼ばれることがあるため
              this.carFormQuickInfo.frontTantoushaCd = this.staffs[0].staffCd;
              this.updateFrontStaff({
                staffCd: this.staffs[0].staffCd,
                staffNm: this.staffs[0].staffNm
              });
            }
          }
        }
      },
      (err: any) => {
        this.staffs = [];
      }
    );
    /** 2021-07-30 sh #6987 implements quick mitsumori.(priority 3) [START] */
    // this.showDialogAskInfo = true;
    /** 2021-07-30 sh #6987 implements quick mitsumori.(priority 3) [END] */

    if (this.carForm.soukouUnitKbn != null) {
      this.changeSoukouUnit();
    }

    this.reqService.getPlateAreasFrequent().then(list => {
      this.listPlateAreaFrequent = list;
    });

    this.reqService.getLaborRate().then((res: any) => {
      if (res && res.length > 0) {
        this.$set(this, "labors", res);
      }
    });
  }

  onSaveAndNext() {
    this.$set(this, "loading", true);
    let data = {
      ...this.carForm,
      shashuRenban: this.shashuRenban // これ必要？？　要確認 TODO
    };

    let dataQuickInfo = {
      ...this.carFormQuickInfo,
      ...this.touroku,
    };

    this.setState(data);
    this.setStateQuickInfo(dataQuickInfo);

    if (this.carForm.soukouKm) {
      this.originalSoukouKm = this.carForm.soukouKm || 0;
      this.originalSoukouMile = this.carForm.soukouMile || 0;
    }

    let mergedData = {
      carSelectionReq: data,
      ...dataQuickInfo
    };

    // console.log("saveCarSelectionQuickMitsumori => data", mergedData);
    this.saveCarSelectionQuickMitsumori(mergedData);
  }

  async saveCarSelectionQuickMitsumori(saveData: any) {

    // クイック見積の情報を保存する
    await this.reqService.saveCarSelectionQuickMitsumori(saveData);

    let sknQuickMitsumoriId = this.currentStateQuickInfo.sknQuickMitsumoriId;
    let sknUketsukeExtendsId = this.currentStateQuickInfo.sknUketsukeExtendsId; // 再読込した時のため


    if (this.carFormQuickInfo.sknQuickMitsumoriId == null) {
      // 新規登録の場合、クイック見積のIDを取得する
      let pQuickMitsumoriObj: any = await this.reqService.getQuickMitsumoriIdByPlateNo(this.touroku);


      // 顧客情報が有れば、それも追加しておく (顧客IDがなければ)
      // console.log("car-selection-quick-mitsumoriid-by-uuid => ", pQuickMitsumoriObj);

      sknQuickMitsumoriId = pQuickMitsumoriObj.sknQuickMitsumoriId;
      sknUketsukeExtendsId = pQuickMitsumoriObj.sknUketsukeExtendsId;
      this.currentStateQuickInfo.sknUketsukeExtendsId = sknUketsukeExtendsId;
    }

    let currentStateQuickInfo = this.currentStateQuickInfo;

    let stateForSave = {
      ...currentStateQuickInfo,
      sknQuickMitsumoriId: sknQuickMitsumoriId
    };
    this.setStateQuickInfo(stateForSave);
    this.setUketsukeExtendsId(sknUketsukeExtendsId);

    let saveCustomData = {
       ...this.customerInfo,
       sknQuickMitsumoriId: sknQuickMitsumoriId,
       kkKbn: 1
    };

    // 顧客情報を保存する
    await this.reqService.saveCarSelectionQuickMitsumoriCustomer(saveCustomData);

    this.setStateQuickCustomerInfo(saveCustomData);

    this.$set(this, "loading", false);
    this.onNext();
  }

  onNext() {
    this.$router.push({ name: "quickitemselection"} );
  }

  // override getData
  /**
   * クイック見積の場合、ここで初期化をしておく必要がある。
   */
  getData() {
    let carForm = this.currentState;
    // console.log("getData => carForm", carForm);

    if (carForm && this.uketsukeExtendsId) {
      let setCarFormObj = {
        ...carForm
      };
      this.carForm = setCarFormObj;

      let carFormQuickInfo = this.currentStateQuickInfo;
      let setCarFormQuickInfoObj = {
        ...carFormQuickInfo
      };
      this.carFormQuickInfo = setCarFormQuickInfoObj;

      let carFormQuickInfoCustomer = this.currentStateQuickCustomerInfo;
      let setCarFormQuickInfoCustomerObj = {
        ...carFormQuickInfoCustomer
      };
      this.customerInfo = setCarFormQuickInfoCustomerObj;

      this.touroku = {
        srPlateAreaCd: carFormQuickInfo.srPlateAreaCd,
        srPlateAreaNm: carFormQuickInfo.srPlateAreaNm,
        srPlateKanaNm: carFormQuickInfo.srPlateKanaNm,
        srPlateModelNm: carFormQuickInfo.srPlateModelNm,
        srPlateNo: carFormQuickInfo.srPlateNo,
      };
    } else {
      this.carForm = {
        sknUketsukeExtendsId: 0,
        jidoushaShubetsu: null,
        youto: null,
        kudouHoushiki: "1",
        katashikiShiteiNo: null,
        ruibetsuKubunNo: null,
        katashiki: null,
        engineKatashiki: null,
        fuelKbn: null,
        shiftKbn: 2,
        meterPanelAlert: null,
        fTireSizeWize: null,
        fTireSizeHenpei: null,
        fTireSizeInchi: null,
        fTireSizeIndex: null,
        rTireSizeWize: null,
        rTireSizeHenpei: null,
        rTireSizeInchi: null,
        rTireSizeIndex: null,
        isWideTire: null,
        fLeftTireNokorimizo: null,
        fRightTireNokorimizo: null,
        rLeftTireNokorimizo: null,
        rRightTireNokorimizo: null,
        brake: null,
        kakyukiKbn: null,
        shashuRenban: null,
        soukouKm: null,
        soukouMile: null,
        soukouUnitKbn: 1,
        soukouBikouKbn: 0,
        sknSaiteiChijouKou: null,
        fRightTireHibi: 0,
        fLeftTireHibi: 0,
        rRightTireHibi: 0,
        rLeftTireHibi: 0,
        fTireSizeRadial: null,
        rTireSizeRadial: null,
        fTireSizeSpeed: null,
        rTireSizeSpeed: null,
        fTireSizeInput: null,
        rTireSizeInput: null,
        fTireSizePlyRating: null,
        rTireSizePlyRating: null,
        sknWorkProgressState: 1
      };
      this.carFormQuickInfo = {
        sknQuickMitsumoriId: null,
        frontTantoushaCd: null,
        isImportCar: null,
        keikaShareki: null,
        srPlateAreaCd: null,
        srPlateModelNm: null,
        srPlateKanaNm: null,
        srPlateNo: null,
        laborRateCd: null,
        laborRateKingakuZn: null
      };
      this.setState({ ...this.carForm });
      this.setStateQuickInfo({ ...this.carFormQuickInfo });
    }
    this.setKbnList();

  }

  setQuickMitsumoriData() {
    /**
     * 一旦初期化しておく
     */
    this.clearState();
    this.clearStateQuickInfo();
    this.clearStateQuickCustomerInfo();

    let carForm = { ...this.currentRowSelectQuick.carSelectionReq };
    let carFormQuickInfoCustomer = { ...this.currentRowSelectQuick.carSelectionCustomerReq };

    let carFormQuickInfo =  { ...this.currentRowSelectQuick };

    /**
     * 要らない項目を省いていく
     */
    delete carFormQuickInfo.carSelectionReq;
    delete carFormQuickInfo.carSelectionCustomerReq;
    delete carFormQuickInfo.createdAt;
    delete carFormQuickInfo.updatedAt;

    this.carForm = carForm;
    this.carFormQuickInfo = carFormQuickInfo;
    this.customerInfo = carFormQuickInfoCustomer;

    this.touroku.srPlateAreaCd = carFormQuickInfo.srPlateAreaCd;
    this.touroku.srPlateAreaNm = carFormQuickInfo.srPlateAreaNm;
    this.touroku.srPlateKanaNm = carFormQuickInfo.srPlateKanaNm;
    this.touroku.srPlateModelNm = carFormQuickInfo.srPlateModelNm;
    this.touroku.srPlateNo = carFormQuickInfo.srPlateNo;

    this.tourokuStaging = this.utils.deepCopy(this.touroku);  // staging
    // console.log("quickInfo.setQuickMitsumoriData tourokuStaging => ", this.tourokuStaging);
    // this.customerNm = this.customerInfo.kojinNmKjSei + '　' + this.customerInfo.kojinNmKjMei;

    if (this.carFormQuickInfo.laborRateCd) {
      let labor = this.labors.find(
        (e: any) => { 
          return e.laborRateCd == this.carFormQuickInfo.laborRateCd;
      });
      this.laborSelected = labor.laborRateCd;
      this.carFormQuickInfo.laborRateNm = labor.bunruiNm;
    }
    this.setState({ ...carForm });
    this.setStateQuickInfo({ ...carFormQuickInfo });
    if (this.customerInfo.id) {
      this.setStateQuickCustomerInfo({ ...this.customerInfo });
    }
  }

  /**
   * 顧客・顧客車両のデータを引用する
   *
   */
  setCustomerCarData() {

    /**
     * いったんクリアする
     */
    this.clearCustomerCarData();

    /**
     * 登録番号の設定
     */
    if (!this.listPlateArea || (this.listPlateArea && this.listPlateArea.length == 0)) {
      let plateAreas = this.reqService.getPlateAreas().then((res: any) => {
        this.listPlateArea = res;
      });
      Promise.all([plateAreas]).then(() => this.setTourokuFromCustomerCarData());
    } else {
      this.setTourokuFromCustomerCarData();
    }

    /**
     * レバレートの設定
     */
    if (this.customerCarDialogSelected.laborRateCd) {
      let labor = this.labors.find(
        (e: any) => { 
          return e.laborRateCd == this.customerCarDialogSelected.laborRateCd;
      });
      this.laborSelected = labor.laborRateCd;
      this.carFormQuickInfo.laborRateNm = labor.bunruiNm;
      this.carFormQuickInfo.laborRateCd = labor.laborRateCd;
      this.carFormQuickInfo.laborRateKingakuZn = labor.shakenTenken;
      // 車検点検:shakenTenken, 一般整備:seibi, 板金塗装:bankin, 保証:hoshou, クレーム:claim
      // クイック見積もりは車検で一旦固定
    }

    /**
     * 都道府県名の設定 (get name from cd)
     */
    const pref = this.listPrefectures.filter( (e: any) => 
      e.prefNm == this.customerCarDialogSelected.customer.jyusho1PrefNm);
    if (pref && pref.length > 0) {
      this.customerInfo.prefCd = pref[0].prefCd;
    }

    this.customerInfo.kojinNmKjMei = this.customerCarDialogSelected.customer.kojinNmKjF;
    this.customerInfo.kojinNmKjSei = this.customerCarDialogSelected.customer.kojinNmKjL;
    this.customerInfo.kojinNmKnMei = this.customerCarDialogSelected.customer.kojinNmKnF;
    this.customerInfo.kojinNmKnSei = this.customerCarDialogSelected.customer.kojinNmKnL;
    this.customerInfo.gender       = this.customerCarDialogSelected.customer.sexKbn;
    this.customerInfo.birthday     = this.customerCarDialogSelected.customer.birthday;
    this.customerInfo.address1     = this.customerCarDialogSelected.customer.jyusho1Addr1;
    this.customerInfo.address2     = this.customerCarDialogSelected.customer.jyusho1Addr2;
    this.customerInfo.prefNm       = this.customerCarDialogSelected.customer.jyusho1PrefNm;
    this.customerInfo.zipcode      = this.customerCarDialogSelected.customer.jyusho1ZipNo;
    this.customerInfo.keitai       = this.customerCarDialogSelected.customer.keitai;
    this.customerInfo.mailAddress  = this.customerCarDialogSelected.customer.pcMailAddr;
    this.customerInfo.vehicleNm    = this.customerCarDialogSelected.customer.vehicleNm;
    this.carFormQuickInfo.kokyakuKanriNo = this.customerCarDialogSelected.kokyakuKanriNo;
    this.carFormQuickInfo.syaryouKanriNo = this.customerCarDialogSelected.syaryouKanriNo;
  }

  clearCustomerCarData() {
    if (this.carFormQuickInfo) {
      this.laborSelected = null;
      this.carFormQuickInfo.laborRateCd = null;
      this.carFormQuickInfo.laborRateNm = null;
      this.carFormQuickInfo.laborRateKingakuZn = null;
      this.carFormQuickInfo.kokyakuKanriNo = null;
      this.carFormQuickInfo.syaryouKanriNo = null;
      this.customerInfo = {
        kojinNmKjMei: "",
        kojinNmKjSei: "",
        kojinNmKnMei: "",
        kojinNmKnSei: "",
        gender: null,
        birthday: null,
        address1: null,
        address2: null,
        prefCd: "",
        prefNm: "",
        zipcode: "",
        keitai: "",
        mailAddress: ""
      };
    }
  }

  setTourokuFromCustomerCarData() {
    let selectPlateArea = this.listPlateArea.filter((e: any) => {
      return e.plateAreaCd == this.customerCarDialogSelected.plateAreaCd;
    });

    if (selectPlateArea && selectPlateArea.length > 0) {
      this.touroku.srPlateAreaNm = selectPlateArea[0].plateAreaNm;
    }
    this.touroku.srPlateAreaCd = this.customerCarDialogSelected.plateAreaCd;
    this.touroku.srPlateKanaNm = this.customerCarDialogSelected.plateKanaNm;
    this.touroku.srPlateModelNm = this.customerCarDialogSelected.plateModelNm;
    this.touroku.srPlateNo = this.customerCarDialogSelected.plateNo;

    // console.log("quickInfo.setTourokuFromCustomerCarData tourokuStaging => ", this.tourokuStaging);
    this.tourokuStaging = this.utils.deepCopy(this.touroku);  // staging
  }

  /**
   * 登録番号のポップアップを開く
   */
  onTourokuBango() {
    this.tourokuStaging = this.utils.deepCopy(this.touroku);
    this.showDialogTouroku = true;
    this.$set(this, "loadingTouroku", true);
    this.reqService.getPlateAreas().then((res: any) => {
      this.$set(this, "loadingTouroku", false);
      if (res) {
        this.listPlateArea = res;
      }
    });
  }

  onChangeSrPlateArea() {
    let selectPlateArea = this.listPlateArea.filter((e: any) => {
      return e.plateAreaCd == this.tourokuStaging.srPlateAreaCd;
    });
    // console.log(selectPlateArea);
    this.tourokuStaging.srPlateAreaNm = selectPlateArea[0].plateAreaNm;
  }

  setPlateAreaCdFromFrequent(frequent: any) {
    this.tourokuStaging.srPlateAreaCd = frequent.srPlateAreaCd;
    this.tourokuStaging.srPlateAreaNm = frequent.srPlateAreaNm;
  }

  onConfirmPlateArea() {
    this.touroku = this.utils.deepCopy(this.tourokuStaging);
    this.showDialogTouroku = false;
    let dataQuickInfo = {
      ...this.carFormQuickInfo,
      ...this.touroku
    };
    // console.log(dataQuickInfo);
    this.setStateQuickInfo(dataQuickInfo);
  }

  /**
   * ポップアップのボタンの活性化制御
   */
  get isConfirmTourokuDisabled() {
    let isOK = true;

    if (!this.tourokuStaging.srPlateAreaCd) {
      isOK = false;
    }

    if (!this.tourokuStaging.srPlateModelNm) {
      isOK = false;
    }

    if (!this.tourokuStaging.srPlateKanaNm) {
      isOK = false;
    }

    if (!this.tourokuStaging.srPlateNo) {
      isOK = false;
    }

    return !isOK;
  }

  onUpdateFront(frontTantoushaCd: string) {
    let selectedStaff = this.staffs.filter(
      (staff: any) => staff.staffCd == frontTantoushaCd
    );
    if (selectedStaff.length > 0) {
      this.updateFrontStaff({
        staffCd: frontTantoushaCd,
        staffNm: selectedStaff[0].staffNm
      });
    }
  }

  get doneTouroku() {
    let ckTouroku: boolean = true;
    if (!this.touroku.srPlateAreaCd) {
      ckTouroku = false;
    }
    if (!this.touroku.srPlateModelNm) {
      ckTouroku = false;
    }
    if (!this.touroku.srPlateKanaNm) {
      ckTouroku = false;
    }
    if (!this.touroku.srPlateNo) {
      ckTouroku = false;
    }
    return ckTouroku;
  }

  get isRequired() {
    let goNext: boolean = true;
    if (this.carForm) {
      if (!this.carForm.jidoushaShubetsu) {
        goNext = false;
      }
      if (!this.carFormQuickInfo.isImportCar) {
        goNext = false;
      }
      /** 2020-12-11 sh delete [START] */
      // if (!this.carForm.fLeftTireNokorimizo) {
      //   goNext = false;
      // }
      // if (!this.carForm.fRightTireNokorimizo) {
      //   goNext = false;
      // }
      // if (!this.carForm.rLeftTireNokorimizo) {
      //   goNext = false;
      // }
      // if (!this.carForm.rRightTireNokorimizo) {
      //   goNext = false;
      // }
      /** 2020-12-11 sh delete [END] */
      // if (!this.carForm.brake) {
      //   goNext = false;
      // }
      if (!this.carForm.youto) {
        goNext = false;
      }
      /** 2021-03-18 sh delete [START] */
      // if (!this.carForm.kudouHoushiki) {
      //   goNext = false;
      // }
      // if (!this.carForm.fuelKbn) {
      //   goNext = false;
      // }
      // if (!this.carForm.shiftKbn) {
      //   goNext = false;
      // }
      // if (!this.carForm.meterPanelAlert) {
      //   goNext = false;
      // }
      // if (!this.checkSoukou) {
      //   goNext = false;
      // }
      /** 2021-03-18 sh delete [END] */
      if (!this.carFormQuickInfo.keikaShareki) {
        goNext = false;
      }
      /** 2021-03-18 sh delete [START] */
      // if (!this.carForm.sknSaiteiChijouKou) {
      //   goNext = false;
      // }
      /** 2021-03-18 sh delete [END] */
      if (!this.touroku.srPlateAreaCd) {
        goNext = false;
      }
      if (!this.touroku.srPlateModelNm) {
        goNext = false;
      }
      if (!this.touroku.srPlateKanaNm) {
        goNext = false;
      }
      if (!this.touroku.srPlateNo) {
        goNext = false;
      }
      if (!this.carFormQuickInfo.laborRateCd) {
        goNext = false;
      }
      /** 2021-07-30 sh #6987 implements quick mitsumori.(priority 3) [START] */
      // if (!this.customerInfo.vehicleNm) {
      //   goNext = false;
      // }
      /** 2021-07-30 sh #6987 implements quick mitsumori.(priority 3) [END] */
    }
    return !goNext;
  }

  public setFormQuickInfo(props: string, params: any) {
    this.carFormQuickInfo[props] = (params == this.carFormQuickInfo[props]
      ? ""
      : +params
    ).toString();
    let dataQuickInfo = {
      ...this.carFormQuickInfo,
    };
    this.setStateQuickInfo(dataQuickInfo);
  }

  onShowDialogInfo() {
    this.showDialogInfo = true;
  }

  onShowDialogLaborRate() {
    if (this.labors && this.labors.length > 0) {
      this.showDialogLaborRate = true;
    } else {
      this.reqService.getLaborRate().then((res: any) => {
        if (res && res.length > 0) {
          this.showDialogLaborRate = true;
          this.$set(this, "labors", res);
        }
      });
    }
  }

  onConvertZipToAddress() {
    if (!this.chkConvertZipToAddress) {
      // 先に表示しておく
      this.showDialogZipselect = true;

      // 3桁以上入力されたら押せるようにする。
      let convertedAddressList = this.reqService.convertZipToAddress(this.customerInfo.zipcode).then( (res: any) => {
        // console.log("onConvertZipToAddress => ", res);
        // 結果が1件の場合は、そのままセットする。2件以上の場合は、ダイアログから選択させる

        if (res && res.length == 1) {
          this.zipselectCurrentRow = res[0];
          this.onConfirmZipselect();
          return;
        }

        if (res && res.length > 1) {
          this.listConvertedZip = res;
        }
      });
    }
  }

  get chkConvertZipToAddress() {
    if (!this.customerInfo || !this.customerInfo.zipcode || this.customerInfo.zipcode.length  <3) {
      return true;
    }
    return false;
  }

  get isConfirmZipselectDisabled() {
    return false;
  }

  onConfirmZipselect() {
    const pref = this.listPrefectures.filter( (e: any) => e.prefNm == this.zipselectCurrentRow.prefName );
    if (pref && pref.length > 0) {
      this.customerInfo.prefCd = pref[0].prefCd;
      this.customerInfo.prefNm = pref[0].prefNm;
      this.customerInfo.address1 = this.zipselectCurrentRow.address;
    }
    this.showDialogZipselect = false;
  }

  onZipSelectRow(row: any ="") {
    if (row != "") {
      this.zipselectCurrentRow = row;
    }
  }

  get torokuBango() {
    if (!this.doneTouroku) { return '登録番号を入力してください。'; }
    
    return this.touroku.srPlateAreaNm
                     + " " + this.touroku.srPlateModelNm
                     + " " + this.touroku.srPlateKanaNm
                     + " " + this.touroku.srPlateNo;
  }

  get donLaborRateNm() {
    return this.carFormQuickInfo.laborRateCd;
  }

  get laborRateNm() {
    return this.donLaborRateNm ? this.carFormQuickInfo.laborRateNm : '未設定';
  }

  laborRateLabel(labor: any) {
    return (
      // 車検点検:shakenTenken, 一般整備:seibi, 板金塗装:bankin, 保証:hoshou, クレーム:claim
      // クイック見積もりは車検で一旦固定
      labor.bunruiNm + " " + this.utils.getNumberThousandSeparate(labor.shakenTenken)
    );
  }

  saveLaborRate() {
    let laborSelected = this.labors.find(
      (e: any) => e.laborRateCd == this.laborSelected
    );
    if (this.laborSelected && laborSelected) {
      // 車検点検:shakenTenken, 一般整備:seibi, 板金塗装:bankin, 保証:hoshou, クレーム:claim
      // クイック見積もりは車検で一旦固定
      this.carFormQuickInfo.laborRateKingakuZn = laborSelected.shakenTenken;
      this.carFormQuickInfo.laborRateCd = laborSelected.laborRateCd;
      this.carFormQuickInfo.laborRateNm = laborSelected.bunruiNm;
    }
    this.showDialogLaborRate = false;
  }

  onSearchQuickMitsumori() {
    this.showDialogQuickMitsumori = true;
  }

  onSearchQuickMitsumoriClose() {
    this.showDialogQuickMitsumori = false;
    if (this.currentRowSelectQuick) {
      this.setQuickMitsumoriData();
    }
  }

  get customerNm() {
    if (this.showDialogAskInfo) {
      return "";
    }
    if (!this.customerInfo.kojinNmKjSei) {
      return "上";
    }
    return this.customerInfo.kojinNmKjSei + '　' + this.customerInfo.kojinNmKjMei;
  }

  get isConfirmCustomerCarSearchDisabled() {
    let isOK = true;

    if (!this.customerCarDialogSelected) {
      isOK = false;
    }

    if (this.customerCarDialogSelected && 
      (!this.customerCarDialogSelected.kokyakuKanriNo 
      || !this.customerCarDialogSelected.syaryouKanriNo)
    ) {
      isOK = false;
    }

    return !isOK;
  }

  onSearchCustomerCar() {
    this.showDialogCustomerCar = true;
  }

  onSearchCustomerCarClose() {
    this.showDialogCustomerCar = false;
    if (this.customerCarDialogSelected) {
      this.setCustomerCarData();
    }
  }

  onCloseSearchCustomerCar() {
    this.showDialogCustomerCar = false;
  }

  onSelectCustomerCarRow(e: any) {
    this.customerCarDialogSelected = e;
  }

  // オーバーライドをしておく。
  changeSoukouUnit() {
    this.updateSoukouUnitKbn(this.carForm.soukouUnitKbn);
  }

  // オーバーライドをしておく。
  changeSoukouBikou() {
    this.updateSoukouBikouKbn(this.carForm.soukouBikouKbn);
  }

  get doneVehicleNm() {
    let ckVehicleNm: boolean = true;
    if (!this.customerInfo.vehicleNm) {
      ckVehicleNm = false;
    }
    return ckVehicleNm;
  }

  get vehicleNm() {
    if (!this.doneVehicleNm) { return '未入力'; }
    
    return this.customerInfo.vehicleNm;
  }

  /** 2021-08-02 sh #6989 change laborRate from popup to direct.(priority 3) [START] */
  onChangeLaborRate(laborRateCd: string) {
    // save labor
    let laborSelected = this.labors.find(
      (e: any) => e.laborRateCd == laborRateCd
    );
    if (this.laborSelected && laborSelected) {
      // 車検点検:shakenTenken, 一般整備:seibi, 板金塗装:bankin, 保証:hoshou, クレーム:claim
      // クイック見積もりは車検で一旦固定
      this.carFormQuickInfo.laborRateKingakuZn = laborSelected.shakenTenken;
      this.carFormQuickInfo.laborRateCd = laborSelected.laborRateCd;
      this.carFormQuickInfo.laborRateNm = laborSelected.bunruiNm;
    }
    this.touroku = this.utils.deepCopy(this.tourokuStaging);
  }
  /** 2021-08-02 sh #6989 change laborRate from popup to direct.(priority 3) [END] */

}
